import config from "../../config/common";
import handleErrors from "./handleErrors";
import logger from "../logger";
import { name, version } from "../../../package.json";

const {
  api: {
    product: {
      search: { retries }
    }
  }
} = config;

let configureRequest, httpsAgent;

if (SERVER) {
  ({ configureRequest } = require("asos-web-base-server"));

  const agentkeepalive = require("agentkeepalive");

  const {
    api: {
      keepAlive: { freeSocketTimeout, inactiveSocketTimeout }
    }
  } = config;

  httpsAgent = new agentkeepalive.HttpsAgent({
    timeout: inactiveSocketTimeout,
    freeSocketTimeout
  });
} else {
  ({ configureRequest } = require("asos-web-request"));
}

const webRequest = configureRequest({
  client: {
    name,
    version
  },
  validateStatus: null,
  retries,
  httpsAgent,
  logger
});

export const request = (url, options, requestType, uuid) =>
  webRequest
    .get({ url, uuid, ...options, additionalLoggingParams: { requestType } })
    .then(handleErrors(requestType))
    .then(({ data }) => data);
